import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./perk-modal.css";

/**
 * PerkDetailModal Component
 *
 * Displays detailed perk information in a modal including description, benefits,
 * terms, and redemption options. Shows HTML-formatted content and provides
 * "Redeem Now" action button. Manages modal visibility with parent callbacks.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.showDetailsModal - Controls modal visibility
 * @param {Function} props.setShowDetailsModal - Toggle modal visibility
 * @param {Object} props.selectedPerk - Perk object with details to display
 * @param {Function} props.handleRedeemNow - Callback when "Redeem Now" clicked
 * @returns {JSX.Element} Perk details modal with HTML content and actions
 */
/**
 * HtmlBlock Component
 *
 * Renders HTML content safely using dangerouslySetInnerHTML.
 * Handles null/undefined content gracefully.
 *
 * @param {Object} props - Component props
 * @param {string} props.html - HTML string to render
 * @returns {JSX.Element} Safe HTML content block
 */
const HtmlBlock = ({ html }) => {
  if (!html) return null;

  return (
    <div
      id="htmlblock"
      className="text-sm text-gray-800 leading-relaxed"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

const PerkDetailModal = ({
  showDetailsModal,
  setShowDetailsModal,
  selectedPerk,
  handleRedeemNow,
}) => {
  return (
    <Modal
      animation={false}
      style={{
        fontFamily: `"AileronRegular", "OpenSansRegular"`,
      }}
      show={showDetailsModal}
      onHide={() => setShowDetailsModal(false)}
      dialogClassName="custom-modal"
      centered
      scrollable
    >
      <div style={{ padding: "1rem", width: "100%", overflowY: "auto" }}>
        <Modal.Header closeButton>
          <Modal.Title>
            <b>{selectedPerk?.name}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HtmlBlock html={selectedPerk?.longDescription} />
          <p>
            <b>Offers:</b>
          </p>
          <HtmlBlock html={selectedPerk?.longOffer} />
          <p>
            <b>Eligibility criteria:</b>
          </p>
          <HtmlBlock html={selectedPerk?.eligibilityCriteria} />
        </Modal.Body>
        <div className="d-grid" style={{ textAlign: "center" }}>
          <Button
            variant="primary"
            onClick={handleRedeemNow}
            className="glintanimation navbarideachecker"
            style={{ width: "fit-content", placeSelf: "center" }}
          >
            {selectedPerk?.actionLabel || "Redeem now"}
          </Button>
        </div>
        <div
          style={{
            textAlign: "right",
            paddingRight: "1rem",
            paddingTop: "1rem",
            paddingBottom: "1rem",
            fontSize: "11px",
          }}
        >
          <HtmlBlock html={selectedPerk?.detailModalFootNote} />
        </div>
      </div>
    </Modal>
  );
};

export default PerkDetailModal;
